import React, { useCallback, useState } from 'react';
import { Button, Flex, InlineFeedback } from '@zillow/constellation';
import { useGetCustomViewsQuery, useSetCustomViewsMutation } from '../../../../../API/pcDashboard/CustomViewsApi';
import { useCustomViewsContext } from '../context/CustomViewsContext';
import { checkForMutationSuccess } from '../../../../../API/checkForMutationSuccess';
import { UUID } from '../../../../../types/shared/UUID';

export const DeleteCustomView: React.FC<{ id: UUID }> = ({ id }) => {
  const [isDeleting, setIsDeleting] = useState(false);

  const { data = {} } = useGetCustomViewsQuery();
  const [setCustomViews] = useSetCustomViewsMutation();
  const { resetContext } = useCustomViewsContext();

  const deleteCustomView = useCallback(
    async (event: React.MouseEvent) => {
      event.stopPropagation();
      const { [id]: _, ...rest } = data;
      const response = await setCustomViews(rest);
      if (checkForMutationSuccess(response, 'deleting custom view')) {
        resetContext();
      }
    },
    [data, setCustomViews, resetContext, id]
  );

  if (isDeleting) {
    return (
      <>
        <InlineFeedback appearance="warning">Are you sure you wish to delete this custom view?</InlineFeedback>
        <Flex display={'flex'} flexDirection={'row-reverse'} gap={'xs'} alignItems={'center'}>
          <Button buttonType={'caution'} onClick={deleteCustomView} type={'button'}>
            Delete
          </Button>
          <Button buttonType={'secondary'} onClick={() => setIsDeleting(false)} type={'button'}>
            Cancel
          </Button>
        </Flex>
      </>
    );
  }

  return (
    <Flex display={'flex'} flexDirection={'row'} alignItems={'center'}>
      <Button buttonType={'caution'} onClick={() => setIsDeleting(true)} type={'button'}>
        Delete
      </Button>
    </Flex>
  );
};
